const messages_pt = require('./messages.json')
export default messages_pt